import React from 'react'
import { Tabs } from 'antd'
import WebIntro from './WebIntro'
import WebOrgan from './WebOrgan'
import WebHonor from './WebHonor'
import WebMain from './WebMain'

function WebAbout() {
    const items = [
        {
            label: '公司简介',
            key: 'intro',
            children: <WebIntro />,
        },
        {
            label: '组织架构',
            key: 'organ',
            children: <WebOrgan />,
        },
        {
            label: '资质荣誉',
            key: 'id',
            children: <WebHonor />,
        },
    ]
    return (
        <WebMain selectedKeys="about">
            <div style={{ backgroundColor: '#fff', padding: '12px 8px 32px' }}>
                <Tabs items={items} size="large" tabPosition="top" />
            </div>
        </WebMain>
    )
}

export default WebAbout
